@if (!drivesRadio) {
  <icc-select-box [title]="'ROLLER_SHUTTER_LEGACY|Sposób sterowania:' | translate"
    [description]="(drive$ | async)?.name"
    [imageUrl]="'/files/rollershutterdrive/' + ((drive$ | async)?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="openModalDrives()"
    [descriptionTemplate]="engineDescription"
    [descriptionContext]="engineDriveDescriptionContext"
  ></icc-select-box>
}

@if (drivesRadio) {
  <div class="box-form mat-elevation-z3">
    <h4>{{ 'ROLLER_SHUTTER_LEGACY|Sposób sterowania:' | translate }}</h4>
    <mat-radio-group name="drive" [ngModel]="driveType$ | async" (ngModelChange)="changeDriveType($event)">
      @if ((driveManuals$ | async)?.length) {
        <mat-radio-button value="manual">{{ 'ROLLER_SHUTTER_LEGACY|Sterowanie ręczne' | translate }}</mat-radio-button>
      }
      @if (showDriveElectrical) {
        <mat-radio-button value="electrical">{{ 'ROLLER_SHUTTER_LEGACY|Sterowanie elektryczne' | translate }}</mat-radio-button>
      }
    </mat-radio-group>
    @if (isShutterToSmallForElectrical) {
      <p>{{ 'ROLLER_SHUTTER_LEGACY|Sterowanie elektryczne dotępne dla rolety o szerokości większej niż' | translate }} {{driveElectricalWidth}} <span>{{ dimensionUnit.unitSymbol }}</span></p>
    }
  </div>
}
@if ((driveType$ | async) == 'electrical' && drivesRadio) {
  <icc-select-box [title]="'ROLLER_SHUTTER_LEGACY|Sposób sterowania:' | translate"
    [description]="(drive$ | async)?.name+' '+(drive$ | async)?.driveEngine?.name"
    [imageUrl]="'/files/rollershutterdrive/' + ((drive$ | async)?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="openModalElectricalDrives()"
    [descriptionTemplate]="engineDescription"
    [descriptionContext]="engineDriveDescriptionContext"
  ></icc-select-box>
}
<ng-template let-system let-engineName="engineName"  let-engineGroupsIndicators="engineGroupsIndicators" let-engineGroups="engineGroups" #engineDescription >
  <p>{{system}}</p>
  @if (engineGroups?.length > 1 || engineGroups[0]?.length > 1) {
    <ul>
      @for (engine of engineGroups; track engine; let i = $index) {
        <li>
          <p>{{('ROLLER_SHUTTER_LEGACY|Kwatera' | translate) + ' ' + engineGroupsIndicators[i] + ': ' + (engineName[engine[0]]?.name ? engineName[engine[0]]?.name : ('ROLLER_SHUTTER_LEGACY|Brak silnika' | translate) )}}</p>
        </li>
      }
    </ul>
  }
  @if (engineGroups?.length === 1 && engineGroups[0]?.length === 1 && engineName[0]?.name ) {
    <p class='engineName'>{{('ROLLER_SHUTTER_LEGACY|Nazwa silnika' | translate) +': '+ engineName[0].name}}</p>
  }
</ng-template>

@if ((showDriveOverride$ | async) && checkOverride('override') && checkOverride('none')) {
  <div class="box-form mat-elevation-z3">
    <mat-radio-group name="driveType" [ngModel]="driveOverride$ | async" (ngModelChange)="changeOverride($event)">
      <mat-radio-button value="none">{{ 'ROLLER_SHUTTER_LEGACY|Bez przeciążenia' | translate }}</mat-radio-button>
      <mat-radio-button value="override">{{ 'ROLLER_SHUTTER_LEGACY|Przeciążeniowy z detekcją przeszkody' | translate }}</mat-radio-button>
    </mat-radio-group>
  </div>
}
@if ((drive$ | async)?.type !== 'manual') {
  <div class="box-form mat-elevation-z3">
    <h4>{{ 'ROLLER_SHUTTER_LEGACY|Dodatki do sterowania:' | translate }}</h4>
    <button mat-flat-button color="primary" (click)="addAccessoriesToDrive()">{{ 'INTERFACE|Dodaj' | translate }}</button>
    @for (item of (driveElements$ | async); track item) {
      <div class="icc-list-item">
        <ng-container *ngTemplateOutlet="accessoryItem;context:{accessory: item}"></ng-container>
      </div>
    }
  </div>
}
@if ((drive$ | async)?.type === 'manual' && !drivesRadio) {
  <icc-select-box [title]="'ROLLER_SHUTTER_LEGACY|Rodzaj sterowania:' | translate"
    [description]="(driveManual$ | async)?.name"
    [imageUrl]="'/files/rollershutterdrivesmanual/' + ((driveManual$ | async)?.image || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="openModalDrivesManuals()"
  ></icc-select-box>
}
@if ((driveManuals$ | async)?.length && (drive$ | async)?.type === 'manual' && drivesRadio && (selectedConfiguratorType$ | async) !== 'external_blind') {
  <div class="box-form mat-elevation-z3">
    <h4>{{ 'ROLLER_SHUTTER_LEGACY|Rodzaj sterowania:' | translate }}</h4>
    <mat-radio-group name="driveManual" [ngModel]="(driveManualType$ | async)" (ngModelChange)="changeDriveManual($event)">
      @for (manual of (driveManuals$ | async); track manual) {
        <mat-radio-button [value]="manual.id">{{ manual.name }}</mat-radio-button>
      }
    </mat-radio-group>
    @if (['r', 'cr'].indexOf((driveManualType$ | async)) > -1) {
      <div>
        <h4>{{ 'ROLLER_SHUTTER_LEGACY|Kolor zwijacza:' | translate }}</h4>
        <icc-list [items]="retractorColors" itemTemplate="itemColor" [scrollable]="false" [selected]="(driveManualTypeColor$ | async)" (select)="changeDriveManualColor($event)">
        </icc-list>
      </div>
    }
  </div>
}
@if (((selectedConfiguratorType$ | async) === 'external_blind' && (driveType$ | async) === 'manual')) {
  <div class="box-form mat-elevation-z3">
    <h4>{{ 'ROLLER_SHUTTER_LEGACY|Korba:' | translate }}</h4>
    @if (!this.isBlindDataStatic) {
      <mat-form-field>
        <mat-label>{{ 'ROLLER_SHUTTER_LEGACY|Długość korby' | translate }}</mat-label>
        <input
          matInput
          iccDimensionInput
          type="number"
          [(ngModel)]="crankLength"
          (ngModelChange)="setCrankLength($event)"
          >
          <span matSuffix>{{ dimensionUnit.unitSymbol }}</span>
        </mat-form-field>
      }
      @if (this.isBlindDataStatic) {
        <mat-form-field>
          <mat-label>{{ 'AWNING|Długość korby' | translate }}</mat-label>
          <mat-select [(ngModel)]="crankLength" (ngModelChange)="setCrankLength($event)">
            @for (crankLength of staticCrankLengths; track crankLength) {
              <mat-option
                [value]="crankLength">
                {{crankLength | translate}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (!this.isBlindDataStatic) {
        <mat-form-field>
          <mat-label>{{ 'ROLLER_SHUTTER_LEGACY|Przesunięcie korby' | translate }}</mat-label>
          <input
            matInput
            iccDimensionInput
            type="number"
            [(ngModel)]="crankOffset"
            (ngModelChange)="setCrankOffset($event)"
            >
            <span matSuffix>{{ dimensionUnit.unitSymbol }}</span>
          </mat-form-field>
        }
        <mat-form-field>
          <mat-label>{{ 'ROLLER_SHUTTER_LEGACY|Nachylenie korby' | translate }}</mat-label>
          <mat-select [(ngModel)]="selectedCrankSlope" (ngModelChange)="setCrankSlope($event)">
            @for (crankSlope of (availableCrankSlopes$ | async); track crankSlope) {
              <mat-option
                [value]="crankSlope">
                {{crankSlope}}
              </mat-option>
            }
          </mat-select>
          <span matSuffix>{{this.isBlindDataStatic ? "°" : dimensionUnit.unitSymbol }}</span>
        </mat-form-field>
      </div>
    }

    @if ((selectedConfiguratorType$ | async) === 'external_blind') {
      <div class="box-form mat-elevation-z3">
        <h4>{{ 'ROLLER_SHUTTER_LEGACY|Uchwyty:' | translate }}</h4>
        @if (!this.isBlindDataStatic) {
          <mat-form-field>
            <mat-label>{{ 'ROLLER_SHUTTER_LEGACY|Długość uchwytów' | translate }}</mat-label>
            <input
              matInput
              iccDimensionInput
              type="number"
              [(ngModel)]="mountingLength"
              (ngModelChange)="setMountingLength($event)"
              >
              <span matSuffix>{{ dimensionUnit.unitSymbol }}</span>
            </mat-form-field>
          }
          @if (this.isBlindDataStatic) {
            <mat-form-field>
              <mat-label>{{ 'ROLLER_SHUTTER_LEGACY|Długość uchwytów' | translate }}</mat-label>
              <mat-select [(ngModel)]="mountingLength" (ngModelChange)="setMountingLength($event)">
                @for (mountingLength of staticMountingLengths; track mountingLength) {
                  <mat-option
                    [value]="mountingLength">
                    {{mountingLength}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
      }

      @if (openingLockAvailable$ | async) {
        <div class="box-form mat-elevation-z3">
          <div>
            <mat-slide-toggle name="openingLock" [disabled]="openingLockDisable$ | async" [ngModel]="openingLock$ | async" (ngModelChange)="changeOpeningLock($event)">{{ 'ROLLER_SHUTTER_LEGACY|Blokada otwarcia' | translate }}</mat-slide-toggle>
            <button mat-flat-button (click)="showInfo()">
              {{getHangerName()}}
              <mat-icon class="mat-18">info</mat-icon>
            </button>
          </div>
        </div>
      }
      @if ((driveOutputSides$ | async)?.length || (driveSideRadio && (driveSides$ | async)?.length) || !driveSideRadio) {
        <div class="box-form mat-elevation-z3">
          @if (driveSideRadio && (driveSides$ | async)?.length) {
            <h4>{{ 'ROLLER_SHUTTER_LEGACY|Strona sterowania' | translate }}</h4>
            <mat-radio-group name="driveSide" [ngModel]="driveSide$ | async" (ngModelChange)="changeDriveSide($event)">
              @for (driveSide of (driveSides$ | async); track driveSide) {
                <mat-radio-button [value]="driveSide.key">{{driveSide.value}}</mat-radio-button>
              }
            </mat-radio-group>
          }
          @if (!driveSideRadio) {
            <button mat-flat-button color="primary" (click)="changeDriveSidePage()">{{ 'ROLLER_SHUTTER_LEGACY|Strona sterowania' | translate }}</button>
          }
          @if ((driveOutputSides$ | async).length>0 && (selectedConfiguratorType$ | async) !== 'external_blind') {
            <h4 class='drive-output-side-heading'>{{ 'ROLLER_SHUTTER_LEGACY|Wyjście sterowania' | translate }}</h4>
          }
          @if ((selectedConfiguratorType$ | async) !== 'external_blind') {
            <div class="drive-output-side">
              @for (side of (driveOutputSides$ | async); track side) {
                <div (click)="changeDriveOutputSide(side)" [class.selected]="(driveOutputSide$ | async) === side" class="mat-elevation-z3">
                  <div class="img">
                    <img [src]="driveOutputSides[side]?.image">
                  </div>
                  <p><a>{{driveOutputSides[side]?.title | translate}}</a></p>
                </div>
              }
            </div>
          }
        </div>
      }

      <ng-template #accessoryItem let-item="accessory">
        <div class="item-imgTitleDescription">
          <img class="item-imgTitleDescription-img" [src]="'/files/windowaccessory/' + item.img" [alt]="item.name">
          <p class="item-imgTitleDescription-title">@if (windowAccessoriesManufacturerCode) {
            <span>{{item.manufacturer_code}} </span>
          }{{item.name}}</p>
          <span class="item-imgTitleDescription-description">
            <small>{{item.code}}</small>
            {{item.description}}
            @if (item.price_type == 1 || item.price_type == 2) {
              <span>
                @if (item.price_type == 1) {
                  <span >
                    {{ 'ROLLER_SHUTTER_LEGACY|Pow.' | translate }}:
                  </span>
                }
                @if (item.price_type == 2) {
                  <span>
                    {{ 'ROLLER_SHUTTER_LEGACY|Dł.' | translate }}:
                  </span>
                }
                <b>
                  @if (item.price_type == 1) {
                    <span ng-bind-html="item.amount | unitm2:1"></span>
                  }
                  @if (item.price_type == 2) {
                    <span>{{item.amount|unitmm:1}}</span>
                  }
                </b>
              </span>
            }
          </span>
          <p class="item-action">
            <button mat-raised-button color="primary" (click)="remove(item)">{{ 'INTERFACE|Usuń'| translate }}</button>
          </p>
        </div>
      </ng-template>
